import { render, staticRenderFns } from "./AmoCrmLink.vue?vue&type=template&id=3a654c7e&scoped=true"
import script from "./AmoCrmLink.vue?vue&type=script&lang=js"
export * from "./AmoCrmLink.vue?vue&type=script&lang=js"
import style0 from "./AmoCrmLink.vue?vue&type=style&index=0&id=3a654c7e&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a654c7e",
  null
  
)

export default component.exports